<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-slide-y-transition group>
        <v-card
          class="pa-3 mb-2 expandableContainer elevation-0"
          v-for="item in newIpads"
          :key="item.id"
        >
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-layout row wrap justify-center fill-height align-center>
                <v-flex xs12>
                  <h2 class="font-weight-regular">Nuevo dispositivo</h2>
                  <p>{{ $t('devices.fixed_assistant') }}</p>
                  <p>
                    1.- Ve a la aplicación del ipad
                    <br />2.- Presiona el botón escanear <br />3.- Apunta el
                    dispositivo al código Qr de la pantalla
                  </p>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4>
              <v-list subheader v-if="isNormalSchool()">
                <v-subheader>
                  {{ $t('devices.permissions') }}
                </v-subheader>

                <v-list-tile
                  v-for="permit in item.permits"
                  :key="permit.id"
                  avatar
                >
                  <v-list-tile-avatar>
                    <v-icon>bookmark</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ translatePermits(permit.name) }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex xs12 sm4>
              <v-layout row wrap justify-center>
                <v-flex xs6>
                  <v-img :src="'data:image/png;base64,' + item.qr"></v-img>
                  <v-btn
                    :disabled="working.w"
                    dark
                    color="gradiente"
                    round
                    @click="cancelInterval"
                  >
                    {{ $t('generic.cancel') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          class="pa-3 mb-2 expandableContainer elevation-0"
          v-for="item in ipads"
          :key="item.id"
        >
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-layout row wrap justify-center fill-height align-center>
                <v-flex xs12>
                  <h2 class="font-weight-regular">
                    {{ $t('devices.synchronized_device') }}
                  </h2>
                  <p style="margin-top: 16px; margin-left: 30px">
                    {{ item.deviceName }}
                    <v-tooltip bottom>
                      <v-btn
                        fab
                        flat
                        small
                        slot="activator"
                        @click="editDeviceName(item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                      <span>Editar nombre</span>
                    </v-tooltip>
                  </p>
                  <v-btn
                    v-if="permits['UNLINK_DEVICES']"
                    dark
                    color="gradiente"
                    round
                    :disabled="working.w"
                    @click="unlink(item)"
                  >
                    {{ $t('devices.unpair') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm4>
              <p>
                {{ $t('devices.fixed_assistant') }}
              </p>
              <v-list subheader v-if="isNormalSchool()">
                <v-subheader>
                  {{ $t('devices.permissions') }}
                  <v-tooltip right>
                    <template>
                      <v-btn
                        fab
                        flat
                        small
                        slot="activator"
                        @click="editDevice(item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar permisos</span>
                  </v-tooltip>
                </v-subheader>

                <v-list-tile
                  v-for="permit in item.permits"
                  :key="permit.id"
                  avatar
                >
                  <v-list-tile-avatar>
                    <v-icon>bookmark</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ translatePermits(permit.name) }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex xs12 sm4>
              <v-layout row wrap justify-center>
                <v-flex xs9>
                  <v-img
                    :src="require('@/assets/panel/devices/sk-qr.png')"
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          class="pa-3 mb-2 elevation-0"
          :key="'loading'"
          v-if="working.loadingList"
        >
          <v-layout row wrap justify-center fill-height align-center>
            <v-flex xs12>
              <h3>
                <b>Cargando</b>
              </h3>
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card
          class="pa-3 mb-2 elevation-0"
          :key="0"
          v-else-if="ipads.length == 0 && newIpads.length == 0"
        >
          <v-layout row wrap justify-center fill-height align-center>
            <v-flex xs12 sm3>
              <v-img
                :src="require('@/assets/panel/devices/new_devices.png')"
              ></v-img>
              <h3 style="color: #545871; font-weight: bold">
                Aún no tienes códigos QR activos
              </h3>
              <h4>
                Presiona el botón + para agregar un dispositivo mediante código
                QR
              </h4>
            </v-flex>
          </v-layout>
        </v-card>
      </v-slide-y-transition>
    </v-flex>
    <editIpadName
      v-model="modals.editIpadReady"
      @cancelled="onCancelEditIpadName"
      :ipad="selected.device"
    ></editIpadName>
    <addIpad
      v-model="modals.addIpad"
      :title="modals.title"
      :device="selected.device"
      v-on:request="beginSync"
      v-on:edited="update"
    ></addIpad>
    <loading v-model="working.w" text="Trabajando..."></loading>
    <success v-model="toast.success" :text="toast.title"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </v-layout>
</template>

<script>
import { clearInterval, setInterval } from 'timers'
import { mapGetters } from 'vuex'
import { isNormalSchool } from '../../../plugins/GeneralMethods'
import error from '../../Dialogs/Error.vue'
import loading from '../../Dialogs/Loading.vue'
import success from '../../Dialogs/Success.vue'
import addIpad from '../../Modals/addIpad'
import editIpadName from './IpadEditModal'

export default {
  components: {
    addIpad,
    editIpadName,
    loading,
    success,
    error,
  },
  props: ['add', 'permits'],
  mounted() {
    if (this.getBranch.id != null) {
      this.getIpads()
    }
  },
  watch: {
    modals: {
      handler(value) {
        if (!value.addIpad) {
          this.$emit('added')
        }
      },
      deep: true,
    },
    getBranch() {
      this.getIpads()
    },
    add() {
      if (this.add) {
        if (!isNormalSchool(this.getBranch)) {
          this.createDirectQR()
        } else {
          this.modals.addIpad = true
          this.modals.title = this.$t('devices.add_device')
        }
      }
    },
  },
  // filters: {
  //   translatePermits(value) {
  //     var permit = ''
  //     if (value == 'Face_Register') {
  //       permit = 'Registro facial'
  //     }
  //     if (value == 'Face_Attendance') {
  //       permit = 'Módulo de asistencia por reconocimiento facial'
  //     }
  //     if (value == 'Manual_Attendance') {
  //       permit = this.$t('devices.access_control')
  //     }
  //     if (value == 'Delivery') {
  //       permit = this.$t('devices.exit_control')
  //     }
  //     return permit
  //   },
  // },
  data: () => ({
    ipads: [],
    newIpads: [],
    selected: {
      device: null,
    },
    loop: {
      loop: null,
      looptime: 0,
    },
    working: {
      w: false,
      loadingList: true,
    },
    toast: {
      success: false,
      failed: false,
      title: '',
    },
    modals: {
      addIpad: false,
      title: '',
      editIpadReady: false,
    },
  }),
  methods: {
    translatePermits(value) {
      var permit = ''
      if (value == 'Face_Register') {
        permit = 'Registro facial'
      }
      if (value == 'Face_Attendance') {
        permit = 'Módulo de asistencia por reconocimiento facial'
      }
      if (value == 'Manual_Attendance') {
        permit = this.$t('devices.access_control')
      }
      if (value == 'Delivery') {
        permit = this.$t('devices.exit_control')
      }
      return permit
    },
    isNormalSchool() {
      if (!isNormalSchool(this.getBranch)) {
        return false
      } else {
        return true
      }
    },
    createDirectQR() {
      this.working.w = true
      this.$store
        .dispatch('employee/genQrCode', [])
        .then((response) => {
          this.working.w = false
          this.toast.title = 'Creación Exitosa'
          this.toast.success = true
          this.$emit('added')
          this.beginSync(response)
        })
        .catch((error) => {
          this.$emit('added')
          this.working.w = false
          this.toast.failed = true
          console.log(error)
        })
    },
    getIpads() {
      this.working.loadingList = true
      this.$store
        .dispatch('employee/getIpads')
        .then((response) => {
          this.working.loadingList = false
          this.ipads = response.data.entity
        })
        .catch((error) => {
          this.working.loadingList = false
          console.log(error)
        })
    },
    beginSync(event) {
      this.$emit('startInterval')
      this.startInterval(event)
      this.newIpads.push(event.data.entity)
    },
    startInterval(event) {
      var v = this
      this.loop.loop = setInterval(() => {
        if (v.loop.looptime < 120) {
          v.$store
            .dispatch('employee/getQR', event.data.entity.id)
            .then((response) => {
              if (response.data.entity.sync) {
                v.stopInterval()
                v.newIpads = []
                v.toast.title = 'Sincronización exitosa'
                v.toast.success = true
                v.getIpads()
              }
            })
            .catch((error) => {
              console.log(error)
            })
          v.loop.looptime++
        } else {
          v.cancelInterval()
        }
      }, 1000)
    },
    editDeviceName(item) {
      this.selected.device = item
      this.modals.editIpadReady = true
    },
    editDevice(item) {
      this.selected.device = item
      this.modals.title = 'Editar permisos'
      this.modals.addIpad = true
    },
    cancelInterval() {
      this.$emit('stopInterval')
      this.deleteNewQR()
      this.stopInterval()
    },
    stopInterval() {
      clearInterval(this.loop.loop)
      this.loop.looptime = 0
      this.$emit('stopInterval')
    },
    deleteNewQR() {
      this.working.w = true
      this.$store
        .dispatch('employee/deleteNewQr', this.newIpads[0].id)
        .then((response) => {
          this.working.w = false
          this.newIpads = []
          this.toast.title = 'Sincronización cancelada'
          this.toast.success = true
        })
        .catch((error) => {
          this.working.w = false
          this.toast.failed = true
          console.log(error)
        })
    },
    unlink(qr) {
      this.working.w = true
      this.$store
        .dispatch('employee/unLinkQR', qr.id)
        .then((response) => {
          this.working.w = false
          this.toast.title = 'Eliminación Exitosa'
          this.toast.success = true
          this.ipads.splice(this.ipads.indexOf(qr), 1)
        })
        .catch((error) => {
          this.working.w = false
          this.toast.failed = true
          console.log(error)
        })
    },
    update(event) {
      this.ipads[this.ipads.indexOf(this.selected.device)].permits =
        event.data.entity
      this.selected.device = null
      this.$forceUpdate()
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancelEditIpadName() {
      this.modals.editIpadReady = false
    },
    onCancel() {
      this.modals.addIpad = false

      this.$forceUpdate()
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  computed: {
    //Mappers
    ...mapGetters(['getBranch']),
  },
}
</script>

<style></style>
